<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Keywords Console</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label for=""><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" >
          <option value=null selected>All</option>
          <option *ngFor="let source of sourceList | keyvalue" [ngValue]="source.key">{{source.value}}</option>
        </select>
      </div>
      <div class="col-2">
        <label for=""><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeFilCountry($event)">
          <option value=null selected>All</option>
          <option *ngFor="let country of countryList" [ngValue]="country">{{country.name}}</option>
        </select>
      </div>
      <div class="col-2">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let operator of filterOperatorList" [value]="operator">{{operator}}</option>
        </select>
      </div>
      <div class="col text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->
  <div class="col-2 ml-auto text-right">
    <button class="btn btn-outline-success text-dark font-weight-bold" (click)="openModal(newKeywordModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Keyword</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="keywordList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead>
    <tr class="text-center">
      <th>ID</th>
      <th>Source</th>
      <th>Country</th>
      <th>ShortCode<br>(SenderID)</th>
      <th>Keyword</th>
      <th>Operator <br> (TelcoId)</th>
      <th>ServiceId<br>/RecId</th>
      <th>Schedule</th>
      <th>Price <br> (PriceId)</th>
      <th>TimeScope</th>
      <th>Mcc&Mnc</th>
      <th>MT Content</th>
      <th>Broadcast</th>
      <th>Renewal</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="15">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="15">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let keyword of keywords; index as i;" class="text-center">
      <td>{{keyword.id}}</td>
      <td>{{keyword.sourceView}}</td>
      <td> {{keyword.country}}</td>
      <td>{{keyword.shortCode}}<br>({{keyword.senderId}})</td>
      <td>{{keyword.keyword}}</td>
      <td>{{keyword.operator}} <br> ({{keyword.operatorId}})</td>
      <td>{{keyword.productId}}</td>
      <td>{{keyword.schedules}}/{{keyword.intervalView}}/{{keyword.categoryView}}</td>
      <td>{{keyword.price}} {{keyword.currency}} <br>
        ({{keyword.priceId}})
      </td>
      <td  class="text-left">MinHour: {{keyword.minHour}} <br> MaxHour: {{keyword.maxHour}}</td>
      <td class="text-left"> Mcc: {{keyword.mcc ? keyword.mcc: '-'}} <br> Mnc: {{keyword.mnc ? keyword.mnc: '-'}}</td>
      <td>{{keyword.mtContentEnabled ? 'Enabled' : 'Disabled'}}</td>
      <td>{{keyword.broadcast ? 'Enabled' : 'Disabled'}}</td>
      <td>{{keyword.renewalEnabled ? 'Enabled' : 'Disabled'}}</td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/tx/keyword-detail', keyword.id]" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteKeyword(keyword)"  *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-trash"></i>
        </button>

        <a class="btn btn-sm btn-primary mt-2" [routerLink]="['/dashboard/tx/kw-msg', keyword.id]">
          <span class="badge">Message</span>
        </a>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="15" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newKeywordModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newKeywordLabel">New Keyword</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newKeyword-modal-body">
    <form [formGroup]="newKeywordForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">

        <div class="col-sm-6">
          <label for="source" class="col-form-label"><span class="text-danger">* </span>Source: </label>
          <select formControlName="source" class="form-control" placeholder="Source">
            <option value="">-select source-</option>
            <option *ngFor="let source of sourceList | keyvalue" [value]="source.key">{{source.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.source.errors">
              Source cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="country" class="col-form-label"><span class="text-danger">* </span>Country: </label>
          <select class="form-control" placeholder="Select" (ngModelChange)="changeCountry($event)" formControlName="country">
            <option value="">-select country-</option>
            <option *ngFor="let country of countryList" [ngValue]="country">{{country.name}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.country.errors">
              Country cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="operator" class="col-form-label"><span class="text-danger">* </span>Operator: </label>
          <select class="form-control" placeholder="Select" formControlName="operator">
            <option value="">-select operator-</option>
            <option *ngFor="let operator of operatorList" [value]="operator">{{operator}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.operator.errors">
              Operator cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="shortCode" class="col-form-label"><span class="text-danger">* </span>Short Code: </label>
          <input type="text" class="form-control" formControlName="shortCode" placeholder="Short Code">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.shortCode.errors">
              Short Code cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="keyword" class="col-form-label"><span class="text-danger">* </span>Keyword: </label>
          <input type="text" class="form-control" formControlName="keyword" placeholder="Keyword">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.keyword.errors">
              Keyword cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="price" class="col-form-label"><span class="text-danger">* </span>Price: </label>
          <input type="number" class="form-control" formControlName="price" placeholder="price">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.price.errors">
              Price cannot be blank.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <label for="category" class="col-form-label"><span class="text-danger">* </span>Category: </label>
          <select class="form-control" placeholder="Select" formControlName="category">
            <option *ngFor="let categoryEle of categoryList" [value]="categoryEle.code">{{categoryEle.name}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.category.errors">
              Category cannot be blank.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <label for="interval" class="col-form-label"><span class="text-danger">* </span>Interval: </label>
          <select class="form-control" placeholder="Select" formControlName="interval">
            <option value="">-select interval-</option>
            <option *ngFor="let interval of intervalList | keyvalue" [value]="interval.key">{{interval.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.interval.errors">
              Interval cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
            <label for="schedules" class="col-form-label"><span class="text-danger">* </span>Schedules:
              &nbsp;<i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/schedule']">View usage</a>
            </label>
            <input type="text" class="form-control" formControlName="schedules" placeholder="split by ,">
            <div class="text-danger small" *ngIf="showError">
              <div *ngIf="f.schedules.errors">
                  Schedules cannot be blank.
              </div>
            </div>
        </div>
        <div class="col-sm-6">
          <label for="contentSchedules" class="col-form-label">Content Schedules:</label>
          <input type="text" class="form-control" formControlName="contentSchedules" placeholder="split by ,">
      </div>
        <div class="col-sm-6">
          <label for="minHour" class="col-form-label"><span class="text-danger">* </span>Min Hour: </label>
          <input type="number" class="form-control" formControlName="minHour" placeholder="minHour" min="0" max="23">
        </div>
        <div class="col-sm-6">
          <label for="maxHour" class="col-form-label"><span class="text-danger">* </span>Max Hour: </label>
          <input type="number" class="form-control" formControlName="maxHour" placeholder="maxHour"  min="0" max="23">
        </div>
        <div class="col-sm-6">
          <label for="mtContentEnabled" class="col-form-label"><span class="text-danger">* </span>With Content When Charge: </label>
          <select class="form-control" placeholder="Select" formControlName="mtContentEnabled">
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="renewalEnabled" class="col-form-label"><span class="text-danger">* </span>Renewal Enabled: </label>
          <select class="form-control" placeholder="Select" formControlName="renewalEnabled">
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="broadcast" class="col-form-label"><span class="text-danger">* </span>Broadcast MT: </label>
          <select class="form-control" placeholder="Select" formControlName="broadcast">
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="secondKeyword" class="col-form-label">Second Keyword: </label>
          <input type="text" class="form-control" formControlName="secondKeyword" placeholder="Second Keyword">
        </div>
        <div class="col-sm-6">
          <label for="productId" class="col-form-label">ServiceId/RecId: </label>
          <input type="text" class="form-control" formControlName="productId" placeholder="ServiceId/RecId">
        </div>
        <div class="col-sm-6">
          <label for="operatorId" class="col-form-label">Operator ID: </label>
          <input type="text" class="form-control" formControlName="operatorId" placeholder="Operator ID">
        </div>
        <div class="col-sm-6">
          <label for="mcc" class="col-form-label">Mobile Country Code: </label>
          <input type="text" class="form-control" formControlName="mcc" placeholder="Mobile Country Code">
        </div>
        <div class="col-sm-6">
          <label for="mnc" class="col-form-label">Mobile Network Code: </label>
          <input type="text" class="form-control" formControlName="mnc" placeholder="Mobile Network Code">
        </div>
        <div class="col-sm-6">
          <label for="priceId" class="col-form-label">Price Tag: </label>
          <input type="text" class="form-control" formControlName="priceId" placeholder="Price Tag">
        </div>
        <div class="col-sm-6">
          <label for="txPrefix" class="col-form-label">TXID Prefix</label>
          <input type="text" class="form-control" formControlName="txPrefix" placeholder="TXID Prefix">
        </div>
        <div class="col-sm-6">
          <label for="senderId" class="col-form-label">Sender ID</label>
          <input type="text" class="form-control" formControlName="senderId" placeholder="Sender ID">
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Keyword</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
